import { FC, Fragment } from 'react'
import { Tooltip, TopBar } from '@reapit/elements'
import { NavigationMenu } from '../types'
import { useNavigationHandler } from '../utils'

interface MainLogoProps extends NavigationMenu {}

export const MainLogo: FC<MainLogoProps> = ({ onClick, href, title }) => {
  const navHandler = useNavigationHandler(href, onClick)
  return (
    <Fragment>
      <TopBar.BrandLogo
        appName="Reapit Sales"
        aria-label="Reapit Sales"
        aria-describedby="tooltip-brand-logo"
        id="brand-logo"
        {...navHandler}
      />
      <Tooltip id="tooltip-brand-logo" triggerId="brand-logo" placement="bottom">
        {title}
      </Tooltip>
    </Fragment>
  )
}
